(function () {
    const newTabAnchors = [...document.querySelectorAll("a[target=_blank], a[target=new]")];
    if (newTabAnchors.length !== 0) {
        newTabAnchors.forEach((newTabAnchor) => {
            const extraText = newTabAnchor.getAttribute("data-new-tab");
            newTabAnchor.setAttribute("rel", "noopener noreferrer");
            const newElement = document.createElement("span");
            newElement.setAttribute("class", "visually-hidden");
            newElement.innerHTML = `(Opens in a new window), ${extraText ? extraText : ""}`;
            newTabAnchor.appendChild(newElement);
        });
    }
})();